import { render, staticRenderFns } from "./ScrollListCompletedGoals.vue?vue&type=template&id=21dc7958&scoped=true&lang=pug"
import script from "./ScrollListCompletedGoals.vue?vue&type=script&lang=js"
export * from "./ScrollListCompletedGoals.vue?vue&type=script&lang=js"
import style0 from "./ScrollListCompletedGoals.vue?vue&type=style&index=0&id=21dc7958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc7958",
  null
  
)

export default component.exports